import type { FormValues, TextFormFields } from '../types.ts';

import { TextField as BraidTextField } from 'braid-design-system';
import { Controller, useFormContext } from 'react-hook-form';
import { createTextFieldValidationRules } from '../validation.ts';
import { parseLabel } from '../parseLabel.tsx';
import { useMemo } from 'react';

interface TextFieldProps {
  element: TextFormFields;
}

export const TextField = ({ element }: TextFieldProps) => {
  const { setValue } = useFormContext<FormValues>();
  const label = useMemo(
    () => parseLabel(element.id, element.label, element.labelLinks),
    [element.id, element.label, element.labelLinks],
  );

  return (
    <Controller
      key={element.id}
      name={element.id}
      rules={createTextFieldValidationRules(element)}
      render={({ field, fieldState }) => (
        <BraidTextField
          label={label}
          placeholder={element.placeholder}
          secondaryLabel={element.secondaryLabel}
          onChange={field.onChange}
          type="text"
          value={field.value}
          message={fieldState.error?.message}
          tone={fieldState.invalid ? 'critical' : undefined}
          onClear={() => setValue(element.id, '')}
        />
      )}
    />
  );
};
